<!--
 * @Author: zfd
 * @Date: 2020-08-21 17:24:24
 * @LastEditTime: 2020-08-29 09:35:21
 * @Description: 
 * @FilePath: \trip-manage\src\Sys.vue
-->
<template>
  <div id="sys">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "Sys",
  data() {
    return {};
  },
  created() {},
  methods: {},
  mounted() {},
};
</script>
<style lang="less">
</style>
